export const URLS = {
	PRODUCERS_WITHOUT_ACCESS: 'produtores-sem-acesso/'
};
